import { render, staticRenderFns } from "./ConfirmService.vue?vue&type=template&id=0b1a1ba1&scoped=true"
import script from "./ConfirmService.vue?vue&type=script&lang=js"
export * from "./ConfirmService.vue?vue&type=script&lang=js"
import style0 from "./ConfirmService.vue?vue&type=style&index=0&id=0b1a1ba1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a1ba1",
  null
  
)

export default component.exports